import { useCallback, useEffect, useRef, useState } from 'react';
import { resolveBurstTone } from './PopBurst.jsx';

const FLOATER_DURATION_MS = 720;
const MAX_FLOATERS = 8;

/**
 * Short-lived "+150" labels at hit positions.
 */
export function useScoreFloaters() {
    const [floaters, setFloaters] = useState([]);
    const timersRef = useRef(new Set());

    const clearTimer = useCallback((timerId) => {
        window.clearTimeout(timerId);
        timersRef.current.delete(timerId);
    }, []);

    useEffect(() => {
        const timers = timersRef.current;
        return () => {
            timers.forEach((id) => window.clearTimeout(id));
            timers.clear();
        };
    }, []);

    const spawnFloater = useCallback(
        (item) => {
            const points = Number(item.points) || 0;
            if (!points) return;

            const floaterId = `floater-${item.id}-${Date.now()}`;
            const tone = resolveBurstTone(item);

            setFloaters((current) => {
                const next = [...current, { id: floaterId, item, points, tone }];
                return next.length > MAX_FLOATERS ? next.slice(-MAX_FLOATERS) : next;
            });

            const timerId = window.setTimeout(() => {
                setFloaters((current) => current.filter((floater) => floater.id !== floaterId));
                clearTimer(timerId);
            }, FLOATER_DURATION_MS);

            timersRef.current.add(timerId);
        },
        [clearTimer],
    );

    return { floaters, spawnFloater };
}
